import { Component, ChangeDetectionStrategy, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { Popover } from 'primeng/popover';
import { NotificacionesService, Notificacion } from '@app/services/notificaciones.service';

const TIPO_ICON: Record<string, string> = {
  'envio.firmado': 'pi-file-check',
  'envio.completado': 'pi-check-circle',
  'envio.expirado': 'pi-clock',
  'envio.revision': 'pi-eye',
  'envio.rebote': 'pi-exclamation-triangle',
  'envio.error': 'pi-times-circle',
  'envio.multiple.completado': 'pi-check-square',
  'pago.completado': 'pi-credit-card',
  'sello.completado': 'pi-stamp',
  'kasm.completado': 'pi-globe',
  'error.nuevo': 'pi-bug',
};

@Component({
  selector: 'app-campana',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, PopoverModule, TooltipModule],
  templateUrl: './campana.component.html',
  styleUrl: './campana.component.scss',
})
export class CampanaComponent {
  @ViewChild('campana') campana!: Popover;

  readonly notifService = inject(NotificacionesService);
  private readonly router = inject(Router);

  iconoPara(notif: Notificacion): string {
    return TIPO_ICON[notif.tipo] ?? 'pi-bell';
  }

  tiempoRelativo(ts: number): string {
    if (!ts) return '';
    const diff = Date.now() - ts;
    const m = Math.floor(diff / 60_000);
    if (m < 1) return 'Ahora mismo';
    if (m < 60) return `Hace ${m} min`;
    const h = Math.floor(m / 60);
    if (h < 24) return `Hace ${h} h`;
    const d = Math.floor(h / 24);
    return `Hace ${d} d`;
  }

  abrir(notif: Notificacion): void {
    this.campana.hide();
    this.notifService.abrir(notif);
  }

  marcarTodas(): void {
    this.notifService.marcarTodasLeidas();
  }

  verTodas(): void {
    this.campana.hide();
    this.router.navigateByUrl('/notificaciones');
  }
}
